import React, { Component } from "react";
import apiInstance from "../apiInstance";
import PopupModal from "./popups/PopupModal";
import Button from "../Button";

class DeavadminProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availableWidgets: [],
      popupModal: React.createRef(),
      error: "",
      filteredWidgets: [],
      searchTerm: "",
      selectedCategory: "",
      minPrice: "",
      maxPrice: "",
      categories: ["feeds", "files", "listings", "reviews", "misc"],
    };
  }

  componentDidMount() {
    apiInstance
      .get("/devadmin/availableWidget")
      .then((response) => {
        const availableWidgets = response.data.availableWidgets;
        this.setState((prevState) => {
          return {
            ...prevState,
            availableWidgets: availableWidgets,
            filteredWidgets: availableWidgets,
          };
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  addAvailableWidget = (widget) => {
    this.setState((prevState) => {
      const updatedAvailableWidgets = [...prevState.availableWidgets, widget];

      return {
        ...prevState,
        availableWidgets: updatedAvailableWidgets,
        filteredWidgets: this.filterWidgets(
          updatedAvailableWidgets,
          prevState.searchTerm,
          prevState.selectedCategory,
          prevState.minPrice,
          prevState.maxPrice
        ),
      };
    });
  };

  updateAvailableWidget = (updatedWidget) => {
    this.setState((prevState) => {
      const updatedAvailableWidgets = prevState.availableWidgets.map((widget) =>
        widget.id === updatedWidget.id ? updatedWidget : widget
      );

      return {
        ...prevState,
        availableWidgets: updatedAvailableWidgets,
        filteredWidgets: this.filterWidgets(
          updatedAvailableWidgets,
          prevState.searchTerm,
          prevState.selectedCategory,
          prevState.minPrice,
          prevState.maxPrice
        ),
      };
    });
  };

  deleteAvailableWidget = (widgetId) => {
    this.setState((prevState) => {
      const updatedAvailableWidgets = prevState.availableWidgets.filter(
        (widget) => widget.id !== widgetId
      );

      return {
        ...prevState,
        availableWidgets: updatedAvailableWidgets,
        filteredWidgets: this.filterWidgets(
          updatedAvailableWidgets,
          prevState.searchTerm,
          prevState.selectedCategory,
          prevState.minPrice,
          prevState.maxPrice
        ),
      };
    });
  };
  // Filter widgets based on search term, category, and price range
  filterWidgets = (
    widgets,
    searchTerm,
    selectedCategory,
    minPrice,
    maxPrice
  ) => {
    return widgets.filter((widget) => {
      // Filter by name (search term)
      const matchesSearch =
        searchTerm === "" ||
        (widget.displayName &&
          widget.displayName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (widget.name &&
          widget.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (widget.desc &&
          widget.desc.toLowerCase().includes(searchTerm.toLowerCase()));

      // Filter by category
      const matchesCategory =
        selectedCategory === "" ||
        (widget.category && widget.category === selectedCategory);

      // Filter by price range
      const minPriceValue = minPrice === "" ? 0 : parseFloat(minPrice);
      const maxPriceValue = maxPrice === "" ? Infinity : parseFloat(maxPrice);
      const widgetPrice = parseFloat(widget.price);
      const matchesPrice =
        !isNaN(widgetPrice) &&
        widgetPrice >= minPriceValue &&
        widgetPrice <= maxPriceValue;

      return matchesSearch && matchesCategory && matchesPrice;
    });
  };

  // Handle search input change
  handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    this.setState((prevState) => ({
      searchTerm: searchTerm,
      filteredWidgets: this.filterWidgets(
        prevState.availableWidgets,
        searchTerm,
        prevState.selectedCategory,
        prevState.minPrice,
        prevState.maxPrice
      ),
    }));
  };

  // Handle category filter change
  handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    this.setState((prevState) => ({
      selectedCategory: selectedCategory,
      filteredWidgets: this.filterWidgets(
        prevState.availableWidgets,
        prevState.searchTerm,
        selectedCategory,
        prevState.minPrice,
        prevState.maxPrice
      ),
    }));
  };

  // Handle min price change
  handleMinPriceChange = (e) => {
    const minPrice = e.target.value;
    this.setState((prevState) => ({
      minPrice: minPrice,
      filteredWidgets: this.filterWidgets(
        prevState.availableWidgets,
        prevState.searchTerm,
        prevState.selectedCategory,
        minPrice,
        prevState.maxPrice
      ),
    }));
  };

  // Handle max price change
  handleMaxPriceChange = (e) => {
    const maxPrice = e.target.value;
    this.setState((prevState) => ({
      maxPrice: maxPrice,
      filteredWidgets: this.filterWidgets(
        prevState.availableWidgets,
        prevState.searchTerm,
        prevState.selectedCategory,
        prevState.minPrice,
        maxPrice
      ),
    }));
  };

  render() {
    const {
      filteredWidgets,
      searchTerm,
      selectedCategory,
      minPrice,
      maxPrice,
      categories,
    } = this.state;
    function getWidgetSrc(imageSrc, name, type) {
      if (imageSrc) {
        return imageSrc.startsWith("devadmin")
          ? `${process.env.REACT_APP_SERVER_URL}/${imageSrc}?ts=${Date.now()}`
          : `${imageSrc}?ts=${Date.now()}`;
      }
      return `/images/${name}-${type}.png`;
    }

    return (
      <div className="mjwidev-main">
        <div style={{ whiteSpace: "nowrap" }} className="mjwidev-main-top">
          <h2>Our Products</h2>
          <div
            className="mjwidev-add-avl-widget-btn mjwi-btn mjwidev-addnew"
            onClick={() =>
              this.state.popupModal.current.openPopup("addAvailableWidget")
            }
          >
            Add New Product
          </div>
        </div>
        <div>
        <div  className="mjwidev-filter-wrapper">
            <div  className="mjwidev-input-field mjwidev-width-40">
            <input
              type="text"
              className=""
              placeholder="Search Product"
              value={searchTerm}
              onChange={this.handleSearchChange}
            />
          </div>
          <div  className="mjwidev-input-field custom-select-wrapper mjwidev-width-40">
            <select
              className=""
              value={selectedCategory}
              onChange={this.handleCategoryChange}
            >
              <option value="">All Categories</option>
              {categories.map((category, index) => (
                <option key={index} value={category}>
                  {category}
                </option>
              ))}
            </select>
            <div  className="custom-arrow mjwidev-top-30">
              <svg
                fill="#ffffff"
                height="16px"
                width="16px"
                viewBox="0 0 330 330"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 
                c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 
                s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                ></path>
              </svg>
            </div>
          </div>
          <div className="mjwidev-input-field ">
              <input
                type="number"
                placeholder="Min price"
                value={minPrice}
                onChange={this.handleMinPriceChange}
              />
            </div>
            <div className="mjwidev-input-field ">
              <input
                type="number"
                placeholder="Max price"
                value={maxPrice}
                onChange={this.handleMaxPriceChange}
              />
            </div>
          </div>
        </div>
        <div className="mjwi-ct-list mjwi-row">
          {filteredWidgets.map((widget) => {
            return (
              <div key={widget.id} className="mjwi-ct-card">
                <div className="mjwi-ct-card-banner">
                  <img
                    src={getWidgetSrc(
                      widget.bannerImage,
                      widget.name,
                      "banner"
                    )}
                    className="mjwi-catalog-banner"
                    onError={(e) => {
                      if (!e.target.src.includes("Default-Widget-Thumb.png")) {
                        e.target.onerror = null;
                        e.target.src = "/images/Default-Widget-Thumb.png";
                      }
                    }}
                    alt="Widget Banner"
                  />
                </div>
                <div className="mjwi-ct-card-logoname">
                  <img
                    src={getWidgetSrc(widget.iconImage, widget.name, "logo")}
                    className="mjwi-catalog-logo"
                    onError={(e) => {
                      if (!e.target.src.includes("Default-Widget-Logo.png")) {
                        e.target.onerror = null;
                        e.target.src = "/images/Default-Widget-Logo.png";
                      }
                    }}
                    alt="Widget Logo"
                  />
                  <h3 className="mjwi-ct-card__title">
                    {widget.displayName || widget.name} <span>${widget.price}</span>
                  </h3>
                </div>
                <div className="mjwi-ct-card-desc">
                  <p>
                    Product ID: <span>{widget.name}</span>
                  </p>
                  <p>
                    Category: <span>{widget.category}</span>
                  </p>
                  <p>
                    Stripe Price ID: <span>{widget.stripePriceId}</span>
                  </p>
                  <p>
                    Stripe Product ID: <span>{widget.stripeProductId}</span>
                  </p>
                  <p>
                    Main script: <span>{widget.scripts.main}</span>
                  </p>
                  <p>
                    Lib script: <span>{widget.scripts.lib}</span>
                  </p>
                </div>
                <div className="mjwi-ct-card-btns">
                  <Button
                    name="Edit"
                    eventHandler={() =>
                      this.state.popupModal.current.openPopup(
                        "updateAvailableWidget",
                        { widget: widget }
                      )
                    }
                  />
                  <Button
                    name="Delete"
                    eventHandler={() =>
                      this.state.popupModal.current.openPopup(
                        "deleteAvailableWidget",
                        { availableWidgetId: widget.id }
                      )
                    }
                  />
                </div>
              </div>
            );
          })}
        </div>
        <PopupModal
          ref={this.state.popupModal}
          addAvailableWidget={this.addAvailableWidget}
          updateAvailableWidget={this.updateAvailableWidget}
          deleteAvailableWidget={this.deleteAvailableWidget}
        />
      </div>
    );
  }
}
export default DeavadminProducts;
